export const logAppError = (error: Error, info: { componentStack: string }) => {
    /**
     * TODO: Do something with the error, e.g. log to an external API
     */
    console.log(error, info);
};
